import { Box } from "flicket-ui";
import { ReactNode, useState } from "react";
import { useIntersectionObserver } from "usehooks-ts";

export type IStickySection = {
  children: ReactNode | ((props: { isSticky: boolean }) => ReactNode);
  options: ArgumentTypes;
  stickyCSS?: any;
};

type ArgumentTypes = Parameters<typeof useIntersectionObserver>[1];

export default function StickySection({
  children,
  options = {},
  stickyCSS,
}: IStickySection) {
  const [isSticky, setIsSticky] = useState(false);

  const { ref } = useIntersectionObserver({
    threshold: 0.98,
    ...options,
    onChange(isIntersecting) {
      setIsSticky(!isIntersecting);
    },
  });

  if (!children) return null;

  return (
    <>
      {/* This is the trigger element */}
      <Box ref={ref}></Box>

      {/* This is the dummy element to prevent content jumping when 
          the sticky element is set to absolute */}
      <Box opacity={isSticky ? 0 : 1}>
        {typeof children === "function" ? children({ isSticky }) : children}
      </Box>

      <Box display={isSticky ? "block" : "none"} css={isSticky && stickyCSS}>
        {typeof children === "function" ? children({ isSticky }) : children}
      </Box>
    </>
  );
}
